export default class LearningDepartmentService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(learningDepartment, options) {
    const response = await fetch(`${this.baseUri}/learning/learningDepartment`, {
      body: JSON.stringify(learningDepartment),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/learning/learningDepartment/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/learningDepartment/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/learning/learningDepartment`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, learningDepartment, options) {
    const response = await fetch(`${this.baseUri}/learning/learningDepartment/${id}`, {
      body: JSON.stringify(learningDepartment),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}